/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   styles.ts
 */

import { type Theme, css } from '@emotion/react'

export const savedCustomMessageToggle = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  margin-top: 2px;
  label: savedCustomMessageToggle;
`

export const savedCustomMessageToggleText = ({ typography, colors }: Theme) => css`
  color: ${colors.textLight};
  font-family: var(--chakra-fonts-body);
  font-size: ${typography.fontSize14};
  font-style: normal;
  font-weight: ${typography.fontWeightLight};
  letter-spacing: -0.2px;
  line-height: ${typography.fontSize20};
  label: savedCustomMessageToggleText;
  padding-bottom: 2px;
`
